import type { FaireProductEntity } from "../../entity_types/product";

export const p_usc3vw8rrv: FaireProductEntity = {
  token: "p_usc3vw8rrv",
  type: "product",
  name: "Wildflowers Single Playing Card Deck",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/7783532f48aa79545b7cc64f98337a54fcf59b76c11e91344ebc332eb0c9b213.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5cc8bd105b7b8a173dfa9381a5806f48cdb62bad2d39fc0454cb671a4fcb270b.jpeg",
  ],
  priceDollars: 8,
  description:
    'This Single Deck of 52 Playing Cards features intricate illustrations of wildflowers originally published in a book by John E. Sowerby in 1902. The antique book was described as a volume of reference for the field botanist, the country resident or the summer rambler to identify each plant. Roomytown\'s design team in Bath, UK have hand picked the most captivating illustrations from this ancient gem to create this unique Playing Card deck, with each card individually designed. Includes standard 52-card deck plus 2 jokers. Packaged in a stylish portable pull-drawer box, it makes an ideal gift.\n\nH 104mm x W 76.2mm x D 30.4mm / H 4.1" x W 3.0" x D 1.2"',
  tags: [],
  msrpDollars: 17.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:46.010Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
